export interface OperationAttempt {
  fingerprint: string;
  body: Record<string, unknown>;
}

/** Retain identifiers and implicit timestamps while retrying an unchanged action. */
export function operationAttempt(
  attempts: Map<string, OperationAttempt>,
  scope: string,
  input: Record<string, unknown>,
  identify: () => Record<string, unknown>,
): Record<string, unknown> {
  const fingerprint = JSON.stringify(input);
  const previous = attempts.get(scope);
  if (previous?.fingerprint === fingerprint) return previous.body;
  const body = { ...input, ...identify(), idempotencyKey: crypto.randomUUID() };
  attempts.set(scope, { fingerprint, body });
  return body;
}
